import { gql } from '@apollo/client'

export const GET_PAYMENT_SETTINGS = gql`
  query GetPaymentSettings {
    getPaymentSettings {
      stripe {
        processor
        configured
        ready
        organisationId
        reason
      }
      gocardless {
        processor
        configured
        ready
        organisationId
        reason
      }
    }
  }
`

export const CREATE_PAYMENT_PROCESSOR_CONNECT_LINK = gql`
  mutation CreatePaymentProcessorConnectLink($processor: PaymentProcessor!) {
    createPaymentProcessorConnectLink(processor: $processor) {
      redirectUrl
    }
  }
`

export const COMPLETE_GOCARDLESS_CONNECTION = gql`
  mutation CompleteGoCardlessConnection(
    $input: CompleteGoCardlessConnectionInput!
  ) {
    completeGoCardlessConnection(input: $input) {
      success
      error
    }
  }
`

export const GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT = gql`
  query GetPaymentProcessorDisconnectImpact($processor: PaymentProcessor!) {
    getPaymentProcessorDisconnectImpact(processor: $processor) {
      eventId
      title
    }
  }
`

export const DISCONNECT_PAYMENT_PROCESSOR = gql`
  mutation DisconnectPaymentProcessor($processor: PaymentProcessor!) {
    disconnectPaymentProcessor(processor: $processor)
  }
`
